import { useState, useRef } from "react";

interface XButtonFormProps {
	onClick: () => void;
	className?: string;
}

export const XButtonForm = (props: XButtonFormProps) => {

	const { 
		onClick = () => { console.log('동작 기능 없음');} ,	
		className = 'right-[1px]'
	} = props;

	const inputRef = useRef<HTMLInputElement>(null);

	return (
		<button
			type="button"
			name="remove_input"
			className={`absolute top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 ${className}`}
			onClick={() => {
				onClick();
				inputRef.current?.focus();
			}}
			tabIndex={-1}
			style={{ padding: 0, background: 'none', border: 'none', fontSize: '18px', lineHeight: 1 }}
		>
			<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M6 6L14 14M14 6L6 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
			</svg>
		</button>
	);
};
